<template>
  <div class="substep-download-app">
    <div class="substep-header">
      <h3 data-testId="step-title">Download the app</h3>
      <p>You're almost there! Finish onboarding by downloading the desktop app to track time to your projects.</p>
    </div>
    <div class="substep-body">
      <div id="download-app-images">
        <img
          v-for="(image, index) in images"
          :key="index"
          :src="image"
          alt="Download App"
        />
      </div>
      <a
        class="btn btn-primary"
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        Download the app
      </a>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import { GETTING_STARTED } from '~/app_constants';

export default {
  name: 'DownloadTheDesktopApp',
  mixins: [GettingStartedMixin],
  props: {
    downloadUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    images: GETTING_STARTED.app_images,
  }),
  mounted() {
    this.$emit('completeSubstep');
  },
};
</script>
